var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-term" },
    [
      _c(
        "el-form",
        {
          ref: "SearchFormItems",
          attrs: { inline: true, model: _vm.searchInfo }
        },
        [
          _vm.searchInfo.sellerId !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("sellerId") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('sellerId')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "油站", name: "sellerId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("sellerId")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.sellerId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "sellerId", $$v)
                          },
                          expression: "searchInfo.sellerId"
                        }
                      },
                      _vm._l(_vm.allStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.stationId !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("stationId") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('stationId')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "油站", name: "stationId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("stationId")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.stationId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "stationId", $$v)
                          },
                          expression: "searchInfo.stationId"
                        }
                      },
                      _vm._l(_vm.allStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.activeStationId !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("activeStationId") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('activeStationId')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "发卡油站", name: "activeStationId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("activeStationId")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.activeStationId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "activeStationId", $$v)
                          },
                          expression: "searchInfo.activeStationId"
                        }
                      },
                      _vm._l(_vm.allStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.cashierShowStations !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("cashierShowStations") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('cashierShowStations')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "收银操作站", name: "cashierShowStations" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          placeholder: "支持收银端操作的站"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("cashierShowStations")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.cashierShowStations,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "cashierShowStations", $$v)
                          },
                          expression: "searchInfo.cashierShowStations"
                        }
                      },
                      _vm._l(_vm.allStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.auditStatus !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("auditStatus") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('auditStatus')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "审核状态", name: "auditStatus" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("auditStatus")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.auditStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "auditStatus", $$v)
                          },
                          expression: "searchInfo.auditStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "1",
                          attrs: { label: "未提交", value: "1" }
                        }),
                        _c("el-option", {
                          key: "2",
                          attrs: { label: "审核中", value: "2" }
                        }),
                        _c("el-option", {
                          key: "3",
                          attrs: { label: "通过", value: "3" }
                        }),
                        _c("el-option", {
                          key: "4",
                          attrs: { label: "不通过", value: "4" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.oilCode !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("oilCode") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('oilCode')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "油品", name: "oilCode" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: {
                          change: function($event) {
                            return _vm.onChange("oilCode")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.oilCode,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "oilCode", $$v)
                          },
                          expression: "searchInfo.oilCode"
                        }
                      },
                      _vm._l(_vm.oilCodesOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.shiftDate !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("shiftDate") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('shiftDate')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "班次日期", name: "shiftDate" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyyMMdd",
                        placeholder: "日期选择",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("shiftDate")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.shiftDate,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "shiftDate", $$v)
                        },
                        expression: "searchInfo.shiftDate"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.goodsName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("goodsName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('goodsName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "商品名称", name: "goodsName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "搜索条件", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("goodsName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.goodsName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "goodsName", $$v)
                        },
                        expression: "searchInfo.goodsName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.giftGoodsName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("giftGoodsName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('giftGoodsName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "商品名称", name: "giftGoodsName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "搜索条件", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("giftGoodsName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.giftGoodsName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "giftGoodsName", $$v)
                        },
                        expression: "searchInfo.giftGoodsName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.goodsNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("goodsNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('goodsNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "条码", name: "goodsNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "搜索条件", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("goodsNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.goodsNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "goodsNo", $$v)
                        },
                        expression: "searchInfo.goodsNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.oilGunNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("oilGunNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('oilGunNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "枪号", name: "oilGunNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "如：1", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("oilGunNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.oilGunNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "oilGunNo", $$v)
                        },
                        expression: "searchInfo.oilGunNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.activityName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("activityName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('activityName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "活动名称", name: "activityName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "搜索条件", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("activityName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.activityName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityName", $$v)
                        },
                        expression: "searchInfo.activityName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.payChannel !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("payChannel") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('payChannel')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "结算方式", name: "payChannel" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("payChannel")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.payChannel,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "payChannel", $$v)
                          },
                          expression: "searchInfo.payChannel"
                        }
                      },
                      _vm._l(_vm.payChannelOption, function(item) {
                        return _c("el-option", {
                          key: item.payChannel,
                          attrs: { label: item.cnName, value: item.payChannel }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.createdAtStart !== undefined &&
          _vm.searchInfo.createdAtEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("createdAtStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('createdAtStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "时间范围", name: "createdAtStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("createdAtStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.createdAtStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "createdAtStart", $$v)
                        },
                        expression: "searchInfo.createdAtStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("createdAtEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.createdAtEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "createdAtEnd", $$v)
                        },
                        expression: "searchInfo.createdAtEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.startTime !== undefined &&
          _vm.searchInfo.endTime !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("startTime") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('startTime')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "时间范围", name: "startTime" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("startTime")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.startTime,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "startTime", $$v)
                        },
                        expression: "searchInfo.startTime"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("endTime")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.endTime,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "endTime", $$v)
                        },
                        expression: "searchInfo.endTime"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.timeStart !== undefined &&
          _vm.searchInfo.timeEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("timeStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('timeStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "时间范围", name: "timeStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "开始日期",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("timeStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.timeStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "timeStart", $$v)
                        },
                        expression: "searchInfo.timeStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束日期",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("timeEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.timeEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "timeEnd", $$v)
                        },
                        expression: "searchInfo.timeEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.activeDateStart !== undefined &&
          _vm.searchInfo.activeDateEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("activeDateStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('activeDateStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "开卡时间", name: "activeDateStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("activeDateStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.activeDateStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activeDateStart", $$v)
                        },
                        expression: "searchInfo.activeDateStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("activeDateEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.activeDateEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activeDateEnd", $$v)
                        },
                        expression: "searchInfo.activeDateEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.shareTimeStart !== undefined &&
          _vm.searchInfo.shareTimeEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("shareTimeStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('shareTimeStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "转赠时间", name: "shareTimeStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("shareTimeStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.shareTimeStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "shareTimeStart", $$v)
                        },
                        expression: "searchInfo.shareTimeStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("shareTimeEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.shareTimeEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "shareTimeEnd", $$v)
                        },
                        expression: "searchInfo.shareTimeEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.acceptTimeStart !== undefined &&
          _vm.searchInfo.acceptTimeEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("acceptTimeStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('acceptTimeStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "领取时间", name: "acceptTimeStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("acceptTimeStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.acceptTimeStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "acceptTimeStart", $$v)
                        },
                        expression: "searchInfo.acceptTimeStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("acceptTimeEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.acceptTimeEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "acceptTimeEnd", $$v)
                        },
                        expression: "searchInfo.acceptTimeEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.useTimeStart !== undefined &&
          _vm.searchInfo.useTimeEnd !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("useTimeStart") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('useTimeStart')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "使用时间", name: "useTimeStart" }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "起始时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("useTimeStart")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.useTimeStart,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "useTimeStart", $$v)
                        },
                        expression: "searchInfo.useTimeStart"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetime",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("useTimeEnd")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.useTimeEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "useTimeEnd", $$v)
                        },
                        expression: "searchInfo.useTimeEnd"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.startAmount !== undefined &&
          _vm.searchInfo.endAmount !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("startAmount") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('startAmount')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "支付金额", name: "startAmount" }
                  },
                  [
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        clearable: "",
                        placeholder: "起始金额"
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("startAmount")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.startAmount,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "startAmount", $$v)
                        },
                        expression: "searchInfo.startAmount"
                      }
                    }),
                    _vm._v("至 "),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        clearable: "",
                        placeholder: "结束金额"
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChange("endAmount")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.endAmount,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "endAmount", $$v)
                        },
                        expression: "searchInfo.endAmount"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.minBalance !== undefined &&
          _vm.searchInfo.maxBalance !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("minBalance") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('minBalance')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "操作金额", name: "minBalance" }
                  },
                  [
                    typeof _vm.searchInfo.minBalance === "number"
                      ? [
                          _c("el-input-number", {
                            attrs: {
                              controls: false,
                              clearable: "",
                              placeholder: "起始金额"
                            },
                            on: {
                              change: function($event) {
                                return _vm.onChange("minBalance")
                              }
                            },
                            model: {
                              value: _vm.searchInfo.minBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "minBalance", $$v)
                              },
                              expression: "searchInfo.minBalance"
                            }
                          }),
                          _vm._v("至 "),
                          _c("el-input-number", {
                            attrs: {
                              controls: false,
                              clearable: "",
                              placeholder: "结束金额"
                            },
                            on: {
                              change: function($event) {
                                return _vm.onChange("maxBalance")
                              }
                            },
                            model: {
                              value: _vm.searchInfo.maxBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "maxBalance", $$v)
                              },
                              expression: "searchInfo.maxBalance"
                            }
                          })
                        ]
                      : _vm._e(),
                    typeof _vm.searchInfo.minBalance === "string"
                      ? [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "起始金额" },
                            on: {
                              change: function($event) {
                                return _vm.onChange("minBalance")
                              }
                            },
                            model: {
                              value: _vm.searchInfo.minBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "minBalance", $$v)
                              },
                              expression: "searchInfo.minBalance"
                            }
                          }),
                          _vm._v("至 "),
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "结束金额" },
                            on: {
                              change: function($event) {
                                return _vm.onChange("maxBalance")
                              }
                            },
                            model: {
                              value: _vm.searchInfo.maxBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "maxBalance", $$v)
                              },
                              expression: "searchInfo.maxBalance"
                            }
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm.searchInfo.mainOrderNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("mainOrderNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('mainOrderNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "订单号", name: "mainOrderNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "订单号", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("mainOrderNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.mainOrderNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "mainOrderNo", $$v)
                        },
                        expression: "searchInfo.mainOrderNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.mobile !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("mobile") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('mobile')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "手机号", name: "mobile" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "完整手机号",
                        clearable: "",
                        maxlength: "11"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("mobile")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.mobile,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "mobile", $$v)
                        },
                        expression: "searchInfo.mobile"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.shareMobile !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("shareMobile") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('shareMobile')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "转赠人手机", name: "shareMobile" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "完整手机号",
                        clearable: "",
                        maxlength: "11"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("shareMobile")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.shareMobile,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "shareMobile", $$v)
                        },
                        expression: "searchInfo.shareMobile"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.acceptMobile !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("acceptMobile") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('acceptMobile')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "领取人手机", name: "acceptMobile" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "完整手机号",
                        clearable: "",
                        maxlength: "11"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("acceptMobile")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.acceptMobile,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "acceptMobile", $$v)
                        },
                        expression: "searchInfo.acceptMobile"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.fullName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("fullName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('fullName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "用户姓名", name: "fullName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("fullName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.fullName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "fullName", $$v)
                        },
                        expression: "searchInfo.fullName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.companyName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("companyName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('companyName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "企业名称", name: "companyName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("companyName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.companyName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "companyName", $$v)
                        },
                        expression: "searchInfo.companyName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.groupName !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("groupName") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('groupName')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "名称", name: "groupName" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("groupName")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.groupName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "groupName", $$v)
                        },
                        expression: "searchInfo.groupName"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.svcNumber !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("svcNumber") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('svcNumber')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "主卡卡号", name: "svcNumber" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("svcNumber")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.svcNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "svcNumber", $$v)
                        },
                        expression: "searchInfo.svcNumber"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.subSvcNumber !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("subSvcNumber") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('subSvcNumber')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "副卡卡号", name: "subSvcNumber" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("subSvcNumber")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.subSvcNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "subSvcNumber", $$v)
                        },
                        expression: "searchInfo.subSvcNumber"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.svcOptNumber !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("svcOptNumber") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('svcOptNumber')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "操作卡号", name: "svcOptNumber" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("svcOptNumber")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.svcOptNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "svcOptNumber", $$v)
                        },
                        expression: "searchInfo.svcOptNumber"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.discountTitle !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("discountTitle") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('discountTitle')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "活动名称", name: "discountTitle" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("discountTitle")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.discountTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "discountTitle", $$v)
                        },
                        expression: "searchInfo.discountTitle"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.ticketRuleNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("ticketRuleNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('ticketRuleNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "券规则编号", name: "ticketRuleNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("ticketRuleNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.ticketRuleNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "ticketRuleNo", $$v)
                        },
                        expression: "searchInfo.ticketRuleNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.ticketNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("ticketNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('ticketNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "用户券编号", name: "ticketNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("ticketNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.ticketNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "ticketNo", $$v)
                        },
                        expression: "searchInfo.ticketNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.shareNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("shareNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('shareNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "分享编号", name: "shareNo" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: {
                        blur: function($event) {
                          return _vm.onChange("shareNo")
                        }
                      },
                      model: {
                        value: _vm.searchInfo.shareNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "shareNo", $$v)
                        },
                        expression: "searchInfo.shareNo"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.optType !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("optType") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('optType')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "操作类型", name: "optType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("optType")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.optType,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "optType", $$v)
                          },
                          expression: "searchInfo.optType"
                        }
                      },
                      _vm._l(_vm.svcOptTypeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.orderOptType !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("orderOptType") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('orderOptType')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "消费类型", name: "orderOptType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("orderOptType")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.orderOptType,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "orderOptType", $$v)
                          },
                          expression: "searchInfo.orderOptType"
                        }
                      },
                      _vm._l(_vm.svcOrderOptTypeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.svcGroupId !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("svcGroupId") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('svcGroupId')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "大客户群", name: "svcGroupId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          remote: "",
                          placeholder: "关键词",
                          "remote-method": _vm.onSearchSvcGroup
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("svcGroupId")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.svcGroupId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "svcGroupId", $$v)
                          },
                          expression: "searchInfo.svcGroupId"
                        }
                      },
                      _vm._l(_vm.svcGroupOptions, function(item) {
                        return _c("el-option", {
                          key: item.groupId,
                          attrs: { label: item.groupName, value: item.groupId }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.groupId !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("groupId") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('groupId')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "大客户群", name: "groupId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          remote: "",
                          placeholder: "关键词",
                          "remote-method": _vm.onSearchSvcGroup
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("groupId")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.groupId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "groupId", $$v)
                          },
                          expression: "searchInfo.groupId"
                        }
                      },
                      _vm._l(_vm.svcGroupOptions, function(item) {
                        return _c("el-option", {
                          key: item.groupId,
                          attrs: { label: item.groupName, value: item.groupId }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.accountType !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("accountType") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('accountType')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "授权账户", name: "accountType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: {
                          change: function($event) {
                            return _vm.onChange("accountType")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.accountType,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "accountType", $$v)
                          },
                          expression: "searchInfo.accountType"
                        }
                      },
                      _vm._l(_vm.svcAccountTypeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.svcStatus !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("svcStatus") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('svcStatus')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "账户状态", name: "svcStatus" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: {
                          change: function($event) {
                            return _vm.onChange("svcStatus")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.svcStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "svcStatus", $$v)
                          },
                          expression: "searchInfo.svcStatus"
                        }
                      },
                      _vm._l(_vm.svcStatusOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.ruleType !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("ruleType") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('ruleType')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "活动类型", name: "ruleType" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: {
                          change: function($event) {
                            return _vm.onChange("ruleType")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.ruleType,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "ruleType", $$v)
                          },
                          expression: "searchInfo.ruleType"
                        }
                      },
                      _vm._l(_vm.shopRuleTypeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.isCashierShow !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("isCashierShow") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('isCashierShow')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "收银端操作", name: "isCashierShow" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          placeholder: "是否支持收银端操作"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("isCashierShow")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.isCashierShow,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "isCashierShow", $$v)
                          },
                          expression: "searchInfo.isCashierShow"
                        }
                      },
                      [
                        _c("el-option", { attrs: { label: "是", value: 1 } }),
                        _c("el-option", { attrs: { label: "否", value: 2 } })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.activityStatus !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("activityStatus") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('activityStatus')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "活动状态", name: "activityStatus" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择" },
                        on: {
                          change: function($event) {
                            return _vm.onChange("activityStatus")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.activityStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                          },
                          expression: "searchInfo.activityStatus"
                        }
                      },
                      [
                        _c(
                          "el-option",
                          { key: 1, attrs: { label: "启用", value: 1 } },
                          [_vm._v("启用")]
                        ),
                        _c(
                          "el-option",
                          { key: 2, attrs: { label: "禁用", value: 2 } },
                          [_vm._v("禁用")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.searchInfo.categoryNo !== undefined
            ? [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.searchBaseItems.includes("categoryNo") ||
                          !_vm.searchMore
                            ? true
                            : _vm.showMore,
                        expression:
                          "searchBaseItems.includes('categoryNo')||!searchMore?true:showMore"
                      }
                    ],
                    attrs: { label: "类目", name: "categoryNo" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChange("categoryNo")
                          }
                        },
                        model: {
                          value: _vm.searchInfo.categoryNo,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "categoryNo", $$v)
                          },
                          expression: "searchInfo.categoryNo"
                        }
                      },
                      _vm._l(_vm.categoryOptions, function(item) {
                        return _c("el-option", {
                          key: item.categoryNo,
                          attrs: { label: item.name, value: item.categoryNo }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _c(
            "span",
            { ref: "SearchMore" },
            [
              _vm.btns.search !== undefined
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$parent.onSearch()
                            }
                          }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.btns.reset !== undefined
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info", plain: "" },
                          on: { click: _vm.onReset }
                        },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.btns.download !== undefined
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.btns.download,
                              expression: "btns.download"
                            }
                          ],
                          attrs: { type: "warning" },
                          on: {
                            click: function($event) {
                              return _vm.$parent.onDownload()
                            }
                          }
                        },
                        [_vm._v("下载")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.searchMore
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary", underline: false },
                          on: {
                            click: function() {
                              _vm.showMore = !_vm.showMore
                              _vm.showMoreText = _vm.showMore
                                ? "点击收起"
                                : "高级搜索"
                              _vm.showMoreIcon = _vm.showMore
                                ? "el-icon-caret-top"
                                : "el-icon-caret-bottom"
                            }
                          }
                        },
                        [
                          _vm._v(_vm._s(_vm.showMoreText)),
                          _c("i", { class: _vm.showMoreIcon })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }